<template>
  <v-list dense>
      <v-list class="pa-1 pl-0" v-if="isMobile">
          <!-- <v-list-tile-action class="pa-1 pl-0" v-if="isMobile"> -->
            <!-- <v-btn icon @click.stop="closeMenuBar()" class="pl-5"> -->
          <v-icon style="float: left" size="35" color="grey darken-1" class="pl-2 mr-7"
            icon @click.stop="closeMenuBar()">chevron_left</v-icon>
            <p class="pt-2 mb-1 font-weight-medium c-pointer" @click.stop="closeMenuBar()">Close</p>
            <!-- </v-btn> -->
          <!-- </v-list-tile-action> -->
      </v-list>
    <v-list-item
      v-for="(routes,index) in router"
      active :key="index"
      v-if="!routes.hidden"
      @click="RouteTo(routes.name)"
      :color="(routes.meta.selected) ? `primary` : ``"
    >
      <v-list-item-action>
        <v-icon :color="(routes.meta.selected) ? `primary` : ``">{{routes.meta.icon}}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title >{{routes.meta.title}}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
      <v-list class="pa-1 ml-2 pl-0" v-if="isMobile">
            <v-icon style="float: left" size="20" color="grey darken-1" class="pl-2 mr-9"
            icon @click="logOut()">fas fa-sign-out-alt</v-icon>
            <p class="pt-0 mb-1 mr-3 font-weight-medium c-pointer" @click="logOut()">Logout</p>
      </v-list>
  </v-list>
</template>
<script>
import { removeCookies } from '@/utils/cookies'
export default {
  props: ['data', 'isMobile'],
  data () {
    return {
      mini: false,
      drawersmall: true,
      mobileDrawer: false,
      drawer: this.data,
      router: this.$router.options.routes
    }
  },
  mounted () {
    console.log('this.$store.getters.menuList', this.$router.options.routes)
    for (let index = 0; index < this.router.length; index++) {
      if (this.$store.getters.isAdmin === false && this.router[index].name !== 'dashboard' && this.router[index].name !== 'filemanager') {
        this.router[index].hidden = this.CheckPermission(this.router[index].meta.permission)
      }
      if (this.$router.currentRoute.name === this.router[index].name) {
        this.router[index].meta.selected = true
      }
    }
  },
  methods: {
    logOut () {
      removeCookies('authToken')
      this.$store.dispatch('SetAdmin', '')
      this.$store.dispatch('SetPermission', [])
      localStorage.removeItem('_dData1')
      localStorage.removeItem('_sData')
      window.location.reload()
    },
    CheckPermission (permission) {
      var staffPErmission = this.$store.getters.permission
      for (let index = 0; index < staffPErmission.length; index++) {
        if (staffPErmission[index].permissionSlug === permission && staffPErmission[index].canViewAll === true) {
          return false
        }
      }
      return true
    },
    RouteTo (path) {
      for (let index = 0; index < this.router.length; index++) {
        if (path === this.router[index].name) {
          this.router[index].meta.selected = true
        } else {
          this.router[index].meta.selected = false
        }
      }
      this.$router.push({name: path})
    },
    closeMenuBar () {
      this.$emit('close-menu-bar', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/admin/layout/components/navigation.vue